export default {
  inserted(el, binding, vnode) {
    const { value }  = binding;
    setTimeout(_=>{
      const scrollWidth = el.parentNode.offsetWidth;
      const offsetWidth = el.offsetWidth;
      if(scrollWidth < offsetWidth) {
        el.onmouseover = debounce(function() {
          return handleMouseover(...arguments, value)
        }, 200)
        el.onmouseout = debounce(function() {
          return handleMouseout(...arguments, value)
        }, 200)
      }
    }, 100)
  }
}

function debounce(func, ms = 1000) {
  let timer;
  return function(...args) {
    const context = this;
    clearTimeout(timer);

    timer = setTimeout(() => {
      func.apply(context, args);
    }, ms);
  }
}

function handleMouseover() {
  const [ e, value ] = arguments;
  const parentNode = e.target.parentNode.parentNode;
  parentNode.style.position = 'relative';
  const tag = parentNode.querySelector('.lsy-tooltips');
  // console.log(tag);
  if(!tag) {
    let div = document.createElement('div');
    div.classList.add('lsy-tooltips');
    div.style.position = 'absolute';
    div.style.padding = '5px';
    div.style.background = '#ffffff';
    div.style.top = '-24px';
    div.style.left = '0';
    div.style.border = '1px solid #eee';
    div.innerHTML = value;
    parentNode.appendChild(div)
  }else{
    tag.style.display = 'block';
  }
}

function handleMouseout() {
  const [ e, value ] = arguments;
  const parentNode = e.target.parentNode.parentNode;
  const tag = parentNode.querySelector('.lsy-tooltips');
  tag.style.display = 'none';
}
